import type { NotificationRecord } from '@billing/validation';
import type { I18nProvider } from '@refinedev/core';

export const getNotificationText = (
  translate: I18nProvider['translate'],
  notification: NotificationRecord
) => {
  const key = `common:notificationCenter.types.${notification.type}`;
  const isKnownSubmissionFailure =
    notification.type === 'submission.failed' &&
    Boolean(notification.data.errors?.length);
  const bodyKey = isKnownSubmissionFailure
    ? `${key}.bodyKnownErrors`
    : `${key}.body`;
  const errors =
    notification.type === 'submission.failed'
      ? notification.data.errors?.join('; ')
      : undefined;
  const bodyOptions: Record<string, unknown> = {
    ...notification.data,
    errors,
  };
  if (notification.type === 'oru.orphaned') {
    bodyOptions.count =
      'count' in notification.data
        ? notification.data.count
        : notification.data.messageIDs.length;
  }

  const titleKey =
    notification.type === 'claimQuery.completed' &&
    notification.data.providerName
      ? `${key}.titleWithProvider`
      : `${key}.title`;

  return {
    title: translate(titleKey, {
      ...notification.data,
    }),
    body: translate(bodyKey, bodyOptions),
  };
};
